import React, { FC, ReactElement } from 'react';

import { observer } from 'mobx-react-lite';
import { allResultsOptions } from 'src/domains/casino/webview/bonus-engine/campaign/action-conditions/ActionConditions.state';
import { MultiOptionSelect } from 'src/domains/common/components/multi-option-select/multi-option-select';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

type ResultsMultiSelectPropsType = {
    formInputState: FormInputState<string, string>;
    disabled: boolean;
};

export const ResultsMultiSelect: FC<ResultsMultiSelectPropsType> = observer(
    ({ formInputState, disabled }): ReactElement => {
        return (
            <MultiOptionSelect
                errors={formInputState.errorsForView}
                formInputState={formInputState}
                label='Results'
                nodes={allResultsOptions}
                disabled={disabled}
                isClearAll={false}
            />
        );
    }
);
